/* @flow */

import { type Voucher } from './types';
import { labelCondicao } from './labels';
import swal from '../swal';
import formatarReal from '../utils/formatar-real';

const porcentagem = ({ tipo, valor }: Voucher) => (tipo === '%' ? `${valor}%` : '');
const dinheiro = ({ tipo, valor }: Voucher) => (tipo === 'R$' ? formatarReal(valor, 'R$') : '');
const valorVoucher = (voucher: Voucher) => dinheiro(voucher) || porcentagem(voucher);

const formatarVoucher = (voucher: Voucher) => `
${voucher.codigo}: ${valorVoucher(voucher)}  ${voucher.condicao ? labelCondicao(voucher.condicao) : ''}
`;

const criarHtmlRadiosVouchers = (vouchers: Voucher[]) => vouchers.map(voucher => `
<div style="text-align: left; padding: 0 20px">
    <label>
        <input type="radio" name="swal2-radio" value="${voucher.codigo}">
        <span class="swal2-label">
        ${formatarVoucher(voucher)}
        </span>
    </label>
</div>
`).join('');

const dialogoSelecaoVoucher = (vouchers: Voucher[]): Promise<?Voucher> => {
    if (vouchers.length === 1) {
        return Promise.resolve(vouchers[0]);
    }

    return swal.fire({
        type: 'question',
        title: 'Selecione um cupom de desconto.',
        // input: 'radio',
        html: criarHtmlRadiosVouchers(vouchers),
        confirmButtonText: 'Selecionar',
        preConfirm: () => {
            const checked = document.querySelector('[name="swal2-radio"]:checked');
            return checked instanceof HTMLInputElement ? checked.value : null;
        },
    })
        .then(({ value }) => vouchers.find(v => v.codigo === value));
};

export default dialogoSelecaoVoucher;
